import React from 'react'
import { Link } from 'react-router-dom'
import { useUser } from '../hooks/useUser'
import FormatCurrency from '../helpers/FormatCurrency'
import AnimatePage from '../components/AnimatePage'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import LinkButton from '../ui/LinkButton'

function Dashboard() {

    const { data } = useUser()

    const { data: orders } = useQuery({
        queryKey: ["orders-cus"],
        queryFn: async () => {
            const res = await apiClient.get('/order/orders')
            return res.data
        }
    })

    return (
        <AnimatePage>
            <div className="bg-containerBg p-5 rounded-lg w-full">
                {/* Welcome Message */}
                <div className="w-full">
                    <h4>Welcome back {data && `${data?.firstname} ${data?.lastname}`}</h4>
                </div>

                {/* Order History */}
                <div className="w-full mt-7">
                    <h2 className='text-xl font-semibold'>Order History</h2>

                    <div className="w-full mt-3">
                        {orders && !orders?.length ? (
                            <div className="bg-green-100 p-4 rounded-md">
                                <Link className='text-green-700' to="/shop">
                                    Make your first order?
                                    <small>You haven't place order yet</small>
                                </Link>
                            </div>
                        ) :
                            <div className="w-full overflow-x-auto whitespace-nowrap">
                                <table className="w-full border">
                                    <thead>
                                        <tr>
                                            <td className='px-2 py-3 border'>Order Date</td>
                                            <td className='px-2 py-3 border'>Total Price</td>
                                            <td className='px-2 py-3 border text-right'>Status</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders?.map((order, i) => (
                                            <tr key={i}>
                                                <td className='px-2 py-3 border'>
                                                    {new Date(order?.iat).toLocaleDateString('en-GB', {
                                                        dateStyle: 'medium'
                                                    })}
                                                </td>
                                                <td className='px-2 py-3 border truncate'><FormatCurrency amount={order?.total} /></td>
                                                <td className='px-2 py-3 border truncate capitalize text-right'>
                                                    <div className="flex justify-end w-full">
                                                        <LinkButton black to={`/order-tracking/${order?.orderNumber}`}>View Order</LinkButton>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        }
                    </div>
                </div>

                {/* Account Details */}
                <div className="w-full mt-7">
                    <h2 className='text-xl font-semibold'>Account Details</h2>

                    <div className="overflow-auto mt-3 w-full">
                        <table className="w-full border">
                            <tbody>
                                <tr>
                                    <td className='px-2 py-3 border'>Name</td>
                                    <td className='px-2 py-3 border truncate'>{data && `${data?.firstname} ${data?.lastname}`}</td>
                                </tr>
                                <tr>
                                    <td className='px-2 py-3 border'>Email</td>
                                    <td className='px-2 py-3 border truncate'>{data && `${data?.email}`}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </AnimatePage>
    )
}

export default Dashboard